import React, { useEffect, useState } from 'react'
import * as Yup from "yup";
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ToastError, ToastSuccess } from "src/components/uiElements/toast";
import { LOGOUT } from "src/components/helper/constants";
import { Select_CustomerMegaMenu } from "src/components/api/customer_mega_menu_mapping/customerMegaMenuMapping";

type RequestProps = {

};

type ResponseProps = {

};

interface MegaMenuSubCategory {
  id: number;
  name: string;
  url: string;
}

interface MegaMenuCategory {
  id: number;
  name: string;
  subCategories: MegaMenuSubCategory[];
}

interface MegaMenuItem {
  id: number;
  name: string;
  menuTypeMasterID: number;
  menuURL: string | null;
  categories: MegaMenuCategory[];
}

interface CustomerSubCategoryResponse {
  ProductSubCategoryMasterID: number;
  ProductSubCategoryName: string;
}

interface CustomerCategoryResponse {
  ProductCategoryMasterID: number;
  ProductCategoryName: string;
  SubCategories: CustomerSubCategoryResponse[];
}

interface CustomerCategoryGroupResponse {
  CustomerCategoryGroupMasterID: number;
  CustomerCategoryGroupName: string;
  Categories: CustomerCategoryResponse[];
}

interface CustomerDepartmentResponse {
  CustomerDepartmentMasterID: number;
  CustomerDepartmentName: string;
  CategoryGroups: CustomerCategoryGroupResponse[];
}

interface CustomerMegaMenuResponse {
  CustomerMenuMasterID: number;
  CustomerMenuName: string;
  MenuTypeMasterID: number;
  MenuURL: string | null;
  Departments: CustomerDepartmentResponse[];
}

interface MegaMenuItem {
  CustomerMenuMasterID: number;
  CustomerMenuName: string;
  MenuTypeMasterID: number;
  MenuURL: string | null;
  Departments: CustomerDepartmentResponse[];

  promotion?: Promotion;
}

interface Promotion {
  title: string;
  description: string;
  buttonText: string;
  image: string;
  backgroundColor?: string;
}

const UseMegaMenu = () => {
    const [loading, setLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [selectMegaMenuList, setSelectMegaMenuList] = useState<MegaMenuItem[]>([]);

    const defaultValues = {
    };

    const validationSchema = Yup.object().shape({
        
    });

    const formContext = useForm<RequestProps>({
        defaultValues,
        resolver: yupResolver(validationSchema) as any,
    });
    const { reset, setValue } = formContext;

    const resetForm = () => {
        reset({
        });
        setIsUpdate(false);
    };

    useEffect(() => {
        SelectMegaMenuList();
    }, []);

    const SelectMegaMenuList = async () => {
        setSelectMegaMenuList([]);
        const response = await Select_CustomerMegaMenu();
        if (!response?.isAuthorized) LOGOUT();
        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }
        var data = JSON.parse(response?.data!);
        setSelectMegaMenuList(data);
    };

    return {
        loading,
        isUpdate,
        selectMegaMenuList,
    }
}

export default UseMegaMenu;
